module.exports = __webpack_public_path__ + "static/media/freelancer.4bde1220.jpg";